import mixitup from 'mixitup';

$(() => {
  // Mobile Nav
  $('#menu-header-menu li.menu-item-has-children').append('<div class="toggle lg:hidden absolute z-20 top-0 right-0 px-2 py-1"><svg class="svg-inline--fa fa-chevron-down fa-w-14" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg></div>');

  var timing = 200;

  $('#menu-header-menu > li.menu-item-has-children > .toggle').click(function () {
    if ($(this).parent().hasClass('open')) {
      $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
      $(this).parent().parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
      $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  $('#menu-header-menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > .toggle').click(function () {
    if ($(this).parent().hasClass('open')) {
      $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
      $(this).parent().parent().find('.sub-menu').slideUp(timing);
    } else {
      $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
      $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
      $(this).parent().toggleClass('open');
      $(this).prev().slideToggle(timing);
    }
  });

  $('#nav-primary-toggle').click(function () {
    $('.nav-primary').toggleClass('open');
    $('.nav-backdrop').toggleClass('show');
  });

  // Desktop Nav
  $('#menu-header-menu > li > .sub-menu > li.menu-item-has-children').hover(function () {
    if ($(window).innerWidth() > 991) {
      var target = $(this).find('> ul.sub-menu');
      var width = $(target).outerWidth();

      var right_of_screen = $(window).innerWidth();
      var right_of_parent = $(this).offset().left + $(this).outerWidth();
      var right_of_element = right_of_parent + width;

      if (right_of_screen > right_of_element) {
        $(target).css('transform', 'translateX(100%)');
        $(target).css('right', '0');
      } else {
        $(target).css('transform', 'translateX(-100%)');
        $(target).css('left', '0');
      }
    }
  });


  // Product Which
  $('.pwModalBtn').on('click', function () {
    $('.' + $(this).data('modal')).addClass('modal-open');
    console.log("modal button clicked");
  });

  $('.modal-close').on('click', function () {
    $('.pwModal').removeClass('modal-open');
    console.log("modal closed");
  });

  $('body').on('click', function (event) {

    if (!$('.pwModal').hasClass('.modal-open')) {

      return;
    } else if (!$(event.target).is('.modal-content')) {
      $('.pwModal').removeClass('modal-open');

    }
  });

  // FAQs
  $('.fFaq').on('click', function () {
    if (!$('.' + $(this).data('faq')).hasClass('fActive')) {
      $('.fActive').removeClass('fActive');
      $('.' + $(this).data('faq')).addClass('fActive');
    }
  });

  // Product FAQs
  $('.pfFaq').on('click', function () {
    if (!$(this).hasClass('pfActive')) {
      $('.pfFaqAnswer').slideUp();
      $('.pfActive').removeClass('pfActive');
      $('.' + $(this).data('faq')).addClass('pfActive').slideDown();
      $(this).addClass('pfActive');
    } else {
      $('.pfFaqAnswer').slideUp();
      $('.pfActive').removeClass('pfActive');
    }
  });

  // Product Brochures & Downloads
  $('.pbdButton').on('click', function () {
    if (!$('.' + $(this).data('pbd')).hasClass('pbdActive')) {
      $('.pbdActive').removeClass('pbdActive');
      $('.' + $(this).data('pbd')).addClass('pbdActive');
      $(this).addClass('pbdActive');
    }
  });

  // Sticky CTA
  $(window).on('scroll', function () {
    if ($(document).scrollTop() > 300) {
      $('.fixed-side').addClass('fixed-side-show');
    } else {
      $('.fixed-side').removeClass('fixed-side-show');
    }

    if ($(document).scrollTop() > 350) {
      $('.fixed-side').addClass('fixed-desktop');
    } else {
      $('.fixed-side').removeClass('fixed-desktop');
    }
  });

  // Button Scroll
  $('.btn-scroll').on('click', function () {
    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top - 200,
        }, 1000);
        return false;
      }
    }
  });


  // Mixitup
  if ($('.mix-container').length) {
    var mixer = mixitup('.mix-container');
    if (mixer) {
      console.log('mix');
    }
  }

  if ($('.product_showcase_mix').length) {

    if (product_showcase_mix) {
      console.log('mix');
    }
  }

  if ($('.product_options_mix').length) {
    var product_options_mix = mixitup('.product_options_mix', {
      load: {
        filter: '.colours',
      },
    });
    if (product_options_mix) {
      console.log('mix');
    }
  }

  $('.option-selector').on('click', function () {
    var selector = $(this).data('option');

    $('.poSlash').hide();
    $('.option-content').hide();
    $('.poSlash[data-option-content="' + selector + '"]').show();
    $('.option-content[data-option-content="' + selector + '"]').show();

    $('.option-selector').css("font-weight", "200");
    $(this).css("font-weight", "500");
  })


  // Share Button
  $('.page-share').click(function () {
    if (navigator.share) {
      navigator.share({
          title: 'Share This Page',
          url: window.location,
        }).then(() => {
          console.log('Thanks for sharing!');
        })
        .catch(err => {
          console.log('Couldnt share because of', err.message);
        });
    } else {
      $('#panel-share').toggleClass('active');
      console.log('navigator.share not supported!')
    }
  });

  $('.panel-share-close').click(function () {
    $('#panel-share').removeClass('active');
  });

  // Slick
  $('.slick-banner').on('init', function () {
    var hiddenSlides = $('.slick-banner .hidden');
    if (hiddenSlides.length > 1) {
      $('.slick-banner .hidden').each(function (i, el) {
        $(el).removeClass('hidden');
      })
    } else {
      hiddenSlides.removeClass('hidden');
    }
  })

  $('.slick-banner-mc-hub').on('init', function () {
    var hiddenSlides = $('.slick-banner-mc-hub .hidden');
    if (hiddenSlides.length > 1) {
      $('.slick-banner-mc-hub .hidden').each(function (i, el) {
        $(el).removeClass('hidden');
      })
    } else {
      hiddenSlides.removeClass('hidden');
    }
  })

  $('.slick-banner').slick({
    dots: false,
    arrows: false,
    fade: true,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 1000,
    infinite: true,
  });


  $('.slick-banner-mc-hub').slick({
    dots: true,
    arrows: false,
    fade: true,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
  });

  $('.boat-stock-slider').slick({
    dots: false,
    arrows: false,
    fade: true,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 1000,
    infinite: true,
  });

  $('.slick-p').click(function () {
    $(this).parent().prev().slick('slickPrev');
  });
  $('.slick-n').click(function () {
    $(this).parent().prev().slick('slickNext');
  });

  $('.slick_product_gallery').slick({
    dots: false,
    arrows: true,
    prevArrow: '.spsLeft',
    nextArrow: '.spsRight',
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    centerMode: false,
    infinite: true,
    swipeToSlide: true,
    draggable: true,
    responsive: [{
        breakpoint: 1535,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $('.slick_other_products').slick({
    dots: false,
    arrows: true,
    prevArrow: '.spsLeft',
    nextArrow: '.spsRight',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    infinite: true,
    swipeToSlide: true,
    draggable: true,
  });

  $('.slick-boat-listing').slick({
    dots: false,
    arrows: true,
    fade: true,
    cssEase: 'ease-in-out',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    swipeToSlide: true,
    pauseOnFocus: true,
    pauseOnHover: true,
    lazyload: 'ondemand',
    speed: 1000,
    infinite: true,
    asNavFor: $('.slick-boat-listing-controls'),
    prevArrow: $('.boat-controls-prev'),
    nextArrow: $('.boat-controls-next'),
  });

  $('.slick-boat-listing-controls').slick({
    dots: false,
    arrows: true,
    fade: false,
    cssEase: 'ease-in-out',
    slidesToShow: 5,
    slidestoScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    swipeToSlide: true,
    speed: 1000,
    infinite: true,
    focusOnSelect: true,
    asNavFor: $('.slick-boat-listing'),
    responsive: [{
      breakpoint: 500,
      settings: {
        slidesToShow: 3,
      },
    }, ],
  });

  $('.slick_testimonials').slick({
    dots: true,
    arrows: false,
    prevArrow: '.stLeft',
    nextArrow: '.stRight',
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
    speed: 1000,
    infinite: true,
    adaptiveHeight: true,
  });

  $('.slick_case_studies').slick({
    dots: false,
    arrows: false,
    slidesToShow: 1,
    slidestoScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
    swipeToSlide: true,
    draggable: true,
  });

  $('.slick_history').slick({
    dots: true,
    arrows: false,
    slidesToShow: 2,
    slidestoScroll: 1,
    speed: 1000,
    infinite: false,
    centerMode: true,
    initialSlide: 1,
    responsive: [{
      breakpoint: 1023,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        initialSlide: 0,
      },
    }, ],
  });


  // Landing Page Gallery Slider
  $('.slick-gallery-landing').slick({
    dots: false,
    infinite: false,
    slidesToShow: 2,
    autoplay: true,
    slidesToScroll: 1,
    draggable: true,
    centerMode: false,
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }]
  });
  // Landing Page Reviews Slider
  $('.slick-reviews-landing').slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    autoplay: true,
    slidesToScroll: 1,
    arrows: false,
    draggable: true,
    centerMode: false,
    autoplaySpeed: 5000,
  });

  $('.set-cookie').click(function () {
    var cookieName = $(this).data('cookie');
    setCookie('boat-type', cookieName, 259200000);
  })

  // Landing Modal
  function showLandingModal() {
    $('.landing-modal').fadeIn();
  }

  function hideLandingModal() {
    $('.landing-modal').fadeOut();
  }

  $('.btn-close').click(function () {
    console.log('test');
    hideLandingModal();
  });

  $('[data-boat-type-cookie]').click(function () {
    var cookieName = $(this).data('boat-type-cookie');
    setCookie('boat-type', cookieName, 259200000);
  })



  // Set Cookies Fn
  function setCookie(key, value, ttl) {
    let now = new Date();
    now.setTime(now.getTime() + (ttl));
    const expires = "expires=" + now.toUTCString();
    document.cookie = key + "=" + value + "; " + expires + "; path=/";
    // Save data to sessionStorage
    sessionStorage.setItem(key, value);
  }

  // Delete Cookies Fn
  function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }
  if (document.cookie.indexOf('boat-type') == -1 ) {
    showLandingModal();
  }


  $('.slick_product_gallery_mc').slick({
    dots: false,
    arrows: true,
    prevArrow: '.spgLeft',
    nextArrow: '.spgRight',
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 1000,
    infinite: true,
    swipeToSlide: true,
    draggable: true,
    responsive: [{
        breakpoint: 1279,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });



  $('.slick_mc_other_products').slick({
    dots: false,
    arrows: true,
    prevArrow: '.mcopLeft',
    nextArrow: '.mcopRight',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 1000,
    infinite: true,
    swipeToSlide: true,
    draggable: true,
  });

  // Product Which


  $('.modal-close').on('click', function () {
    $('.pwModal-mc').removeClass('modal-open');
    console.log("modal closed");
  });

  $('body').on('click', function (event) {
    if ($(event.target).hasClass('modal-open')) {
      $('.pwModal-mc').removeClass('modal-open');
    }
  });

  $('.slick_product_which').slick({
    dots: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2500,
    speed: 1000,
    prevArrow: '.spwLeft',
    nextArrow: '.spwRight',
    arrows: true,
    infinite: false,
    swipeToSlide: true,
    draggable: true,
    responsive: [{
        breakpoint: 1600,
        settings: {
          slidesToShow: 2,
          infinite: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          infinite: false,
        },
      },
    ],
  });


  //Brochure Tabs

  $('[data-name]').click(function () {
    $('[data-tab]').hide();
    var target = $(this).data('name');
    $('[data-tab="' + target + '"]').fadeIn('fast');
    $('[data-name]').removeClass('tab-active');
    $(this).addClass('tab-active');
    $(this).parent().parent().attr('data-boat-type', target);
  })

  //Instagram Tabs

  $('[data-ig-name]').click(function () {
    $('[data-ig-tab]').hide();
    var target = $(this).data('ig-name');
    $('[data-ig-tab="' + target + '"]').fadeIn('fast');
    $('[data-ig-name]').removeClass('tab-active');
    $(this).addClass('tab-active')
    $(this).parent().parent().attr('data-boat-type', target);
    console.log($(this).parent().parent().data('boat-type'));
  })

  //Gallery Filters
  $('[data-filter=".mastercraft"]').click(function () {
    $('[data-filter=".nxt"], [data-filter=".xt"], [data-filter=".x"], [data-filter=".prostar"], [data-filter=".xstar"], [data-filter=".surfstar"]').show();
    $('[data-filter=".catamarans"], [data-filter=".monohulls"]').hide();
  })
  $('[data-filter=".invincible"]').click(function () {
    $('[data-filter=".catamarans"], [data-filter=".monohulls"]').show();
    $('[data-filter=".nxt"], [data-filter=".xt"], [data-filter=".x"], [data-filter=".prostar"], [data-filter=".xstar"], [data-filter=".surfstar"]').hide();
  })
});